import { render, staticRenderFns } from "./ContactPeru.vue?vue&type=template&id=25089baa&"
import script from "./ContactPeru.vue?vue&type=script&lang=ts&"
export * from "./ContactPeru.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports